export const isBeta = process.env.NEXT_PUBLIC_DEPLOYMENT_TARGET === 'beta'
export const isProd = process.env.NEXT_PUBLIC_DEPLOYMENT_TARGET === 'prod'

export const deploymentConfig = {
	mediaMapUrl: isBeta
		? 'http://rating.nfnz.cz.s3.amazonaws.com/mapa_medii_json/mamamedii_beta.json'
		: 'http://rating.nfnz.cz.s3.amazonaws.com/mapa_medii_json/mapamedii.json',
	enableMediaTypeFilter: isBeta,
	enableMediumRedirect: isProd,
}
